<template>
  <div>
    <!-- <div class="heading">Promo</div> -->
    <div class="left-panel">
      <div class="heading">
        <!-- <span>Promo Details</span> -->
        <label>PROMO DETAILS</label>

        <div class="button-actions">
          <div :class="['button cta small', edit ? 'error' : 'warning', viewSaving ? 'disabled' : '']"
            @click="toggleEdit">
            <span v-if="!edit">edit</span>
            <span v-else>cancel</span>
          </div>
          <div :class="{'button cta small success':true, 'disabled':edit || viewSaving}"
            @click="exportPromo($route.params.id)">export</div>
        </div>

      </div>

      <transition name="slide-down">
        <promo-view-edit v-show="edit" ref="viewEdit"></promo-view-edit>
      </transition>
      <promo-view-details v-show="!edit"></promo-view-details>

      <transition name="slide-up">
        <div class="fix-footer" v-if="edit">
          <div class="row">
            <div class="column small-4 small-offset-2">
              <div :class="{'button cta error block small': true, 'disabled':viewSaving}"
                @click="edit = false">Cancel</div>
            </div>
            <div class="column small-4 end">
              <div :class="{'button cta success block small': true, 'disabled':viewSaving}"
                @click="save">
                <span v-if="!viewSaving">Save</span>
                <span v-else>
                  <i class="fas fa-spinner fa-spin"></i>
                  Loading
                </span>
              </div>
            </div>
          </div>
        </div>
    </transition>
    </div>

    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showRecords ? 'mobile-right-panel' : '']" @scroll="onScroll">
      <promo-view-list :showFixedHeader="showFixedHeader" :isMobile="isMobile"></promo-view-list>
    </div>

    <loading-modal :showModal="dataLoading"
      modalMessage="Getting Promo Data..."></loading-modal>
  </div>
</template>

<script>
import CsvExport from 'csvexport'
import ApiPromo from '@/modules/api/promo'
import promoViewDetails from './PromoViewDetails'
import promoViewEdit from './PromoViewEdit'
import promoViewList from './PromoViewList'
import loadingModal from '../Partials/LoadingModal'

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [ '#', 'Promo Code', 'Status', 'Consumer ID', 'Redeemed Date', 'Expiration Date' ]
})

export default {
  name: 'promo-view',
  components: { promoViewDetails, promoViewEdit, promoViewList, loadingModal },
  data () {
    return {
      dataLoading: false,
      showFixedHeader: false,
      edit: false,
      showRecords: false,
      isMobile: false
    }
  },
  computed: {
    promo () { return this.$store.state.promo.list },
    promoCode () { return this.$store.state.promo.view.details.code },
    viewSaving () { return this.$store.state.promo.view.saving },
  },
  methods: {
    init () {
      let self = this
      self.setScreenSize()
      let id = self.$route.params.id
      self.dataLoading = true
      ApiPromo.getPromoDetails(self, id, res => {
        self.dataLoading = false
        if (res.error) {
          window.location = "/#/thispagedoesnotexist"
          return
        }

        self.$store.commit('promo/setViewLoading', true)
        ApiPromo.getViewList(self, id, res => {
          self.$store.commit('promo/setViewLoading', false)
        })
      })
    },
    onScroll (event) { this.showFixedHeader = event.target.scrollTop > 10 },
    toggleEdit () {
      if (this.edit) {
        this.edit = false
      } else {
        let details = this.$store.state.promo.view.details
        this.$store.commit('promo/setViewDetails', '')

        this.$store.commit('promo/setViewDetails', details)
        this.edit = true
      }
    },
    save () {
      if (this.$refs.viewEdit.save()) {
        this.$refs.viewEdit.save()
      }
    },
    exportPromo (id) {
      let self = this
      ApiPromo.getViewListFull(self, id, function (res) {
        console.log('EXPORT', res)
        exporter.downloadCsv(res)
      })
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 40%;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;

  .heading{
    padding: 0 15px 0 65px;
    line-height: 50px;
    font-size: 21px;
    font-weight: 600;
    background: #fff;
    border-bottom: 1px solid #eee;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    label{
      color:#3F2975;
      text-transform: uppercase;
    }
    div{
      margin: 5px 5px 0;
      float: right;
    }

    .button-actions {
      margin: 5px;
    }
  }
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 40%;
  height: 50px;
  padding-top: 5px;
  background: #fafafa;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .small-4{ padding: 0 10px; }
}

.toggle-mobile {
  display: none;
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: 60%;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #fff;
  overflow-y: auto;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-up-enter-active, .slide-up-leave-active { transition: all .25s ease }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .left-panel {
    width: 100%;
    padding-bottom: 100px;
    .heading {
      padding: 0 20px;
      position: absolute;
      width: 100%;

      label {
        margin-left: 40px;
      }
      .button-actions {
        margin: 0;
        margin-bottom: 10px;
      }
      div {
        float: none;
        margin: 0;
        .button {
          width: 50%;
        }
      }
    }

    .tab {
      margin: 35px 0 0;
      display: flex;
      overflow-x: scroll;

      li {
        width: auto;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    z-index: 1;
    width: 100%;
    top: 100%;
    transition: all 0.3s ease;

    &.mobile-right-panel {
      top: 0;
      z-index: 2;

      .tab {
        margin-top: 70px;
        display: flex;
        overflow-x: scroll;
      }

      .tab-contents {
        width: 100%;
        height: calc(100vh - 142px);
        overflow-y: scroll;
        .tab-content {
          padding-bottom: 60px;

          &.history-panel {
            padding: 0;
            padding-top: 20px;
            padding-bottom: 60px;
          }

        }
        .fixed-footer {
          width: 100%;
          bottom: 45px;
          background: #fff;
          color: #000;
          border-top: 1px solid #aaa;
        }
      }

      .logs-panel {
        width: 100%;
      }
    }
  }

  .fix-buttons {
    width: 100%;
    bottom: 45px;
    a {
      margin: 0 auto;
    }
  }

  .toggle-panel .heading {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/PromoView.vue